import { SheetColumnDef, SheetSortDef } from "./types";

/** Sort an array by one or more SheetSortDef rules */
export function sortData<T>(data: T[], sort?: SheetSortDef<T>[]): T[] {
  if (!sort || sort.length === 0) return data;

  return [...data].sort((a, b) => {
    for (const { key, direction } of sort) {
      const va = a[key];
      const vb = b[key];

      if (va! < vb!) return direction === "asc" ? -1 : 1;
      if (va! > vb!) return direction === "asc" ? 1 : -1;
    }

    return 0;
  });
}

/** Trigger a download of CSV content */
export function downloadCSV(
  filename: string,
  headers: string[],
  rows: any[][]
): void {
  const lines = [
    headers.join(","),
    ...rows.map((cols) =>
      cols.map((cell) => JSON.stringify(cell ?? "")).join(",")
    ),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Infer columns (keys) from first row of data */
export function inferColumns<T>(data: T[]): SheetColumnDef<T>[] {
  if (data.length === 0) return [];

  return (Object.keys(data[0] as object) as Array<keyof T>).map((key) => ({
    key,
  }));
}
